export const MAX_NUMBER_OF_GROUPS = 10;

export const SERIES_BY_MEDIA = {
  all: {
    bar: {
      color: '#777D96',
    },
    facebook: {
      color: '#1877F2',
    },
    instagram: {
      color: '#E1306C',
    },
    twitter: {
      color: '#58A0F2',
    },
    youtube: {
      color: '#FF0000',
    },
    positivo: {
      color: '#18BF29',
    },
    neutro: {
      color: '#FFAE35',
    },
    negativo: {
      color: '#FF1300',
    },
    'não classificado': {
      color: '#B7B9BC',
    },
  },
  facebook: {
    imagem: {
      color: '#073B7E',
    },
    'multimídia': {
      color: '#1262C9',
    },
    texto: {
      color: '#58A0F2',
    },
    'vídeo': {
      color: '#A1C9F7',
    },
    bar: {
      color: '#1877F2',
    },
    'curtidas/gostei': {
      color: '#073B7E',
    },
    'comentários': {
      color: '#1262C9',
    },
    'compartilhamento': {
      color: '#58A0F2',
    },
    positivo: {
      color: '#18BF29',
    },
    neutro: {
      color: '#FFAE35',
    },
    negativo: {
      color: '#FF1300',
    },
    'não classificado': {
      color: '#B7B9BC',
    },
  },
  instagram: {
    carrossel: {
      color: '#722237',
    },
    imagem: {
      color: '#DB426A',
    },
    'vídeo': {
      color: '#F2A2B7',
    },
    bar: {
      color: '#E1306C',
    },
    'curtidas/gostei': {
      color: '#692837',
    },
    'comentários': {
      color: '#D1647E',
    },
  },
  twitter: {
    imagem: {
      color: '#084B75 ',
    },
    texto: {
      color: '#116EA7',
    },
    'vídeo': {
      color: '#1A92DD',
    },
    bar: {
      color: '#1DA1F2',
    },
    'curtidas/gostei': {
      color: '#004268',
    },
    'comentários': {
      color: '#00639A',
    },
    'compartilhamento': {
      color: '#0087D4',
    },
    positivo: {
      color: '#18BF29',
    },
    neutro: {
      color: '#FFAE35',
    },
    negativo: {
      color: '#FF1300',
    },
    'não classificado': {
      color: '#B7B9BC',
    },
  },
  youtube: {
    bar: {
      color: '#FF0000',
    },
    'vídeo': {
      color: '#FF0000',
    },
    'curtidas/gostei': {
      color: '#611D1D',
    },
    'comentários': {
      color: '#E10101',
    },
    positivo: {
      color: '#18BF29',
    },
    neutro: {
      color: '#FFAE35',
    },
    negativo: {
      color: '#FF1300',
    },
    'não classificado': {
      color: '#B7B9BC',
    },
  },
};
